import { render } from "./DesktopHeader.vue?vue&type=template&id=4271dac7&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./DesktopHeader.vue?vue&type=script&lang=js"
export * from "./DesktopHeader.vue?vue&type=script&lang=js"

import "./DesktopHeader.vue?vue&type=style&index=0&id=4271dac7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4271dac7"]])

export default __exports__